<template>
  <div class="c-form c-form-compressed">
    <div class="c-form-field c-form-field-text" v-bind:class="{ 'is-dirty': value }">
      <label for="pickupInput">{{ searchLabel }}</label>

      <!-- The first element for the combobox has a role of combobox and behaves like an input text field -->
      <!-- The combobox must have aria-expanded = true if the list is displayed or aria-expanded = false when it is not -->
      <input class="c-predictive-input" 
        ref="pickupInput"
        id="pickupInput" 
        name="pickupInput"
        type="text" 
        role="combobox" 
        autocomplete="off" 
        aria-autocomplete="both"
        aria-expanded="false" 
        aria-owns="predictiveList"
        v-bind:aria-activedescendant="current > 0 ? `suggestion-${current}` : null"
        :value="value"
        @input="updateValue($event.target.value)"
        @keydown.38="up"
        @keydown.40="down"
        @keydown.prevent.enter="submit($event.target.value)"
        @blur="blur">

      <p aria-live="polite" aria-atomic="true" class="show-for-sr">
        <template v-if="suggestions.length > 0">
          {{ suggestions.length }} suggestions found. {{ srLabel }}
        </template>
      </p>
      
      <div role="listbox" v-bind:class="{ 'is-empty': !openSuggestion }" id="predictiveList" class="c-predictive-list">
        <!-- The next element has a listbox role and represents the drop down list. -->
        <ul class="is-list-unstyled">
          <!-- Each item in the listbox is an option. Options are not in the tab order. -->
          <li 
            role="option"
            class="c-predictive-item"
            v-on:click="click(suggestion.description)"
            v-bind:id="`suggestion-${index + 1}`"
            v-bind:aria-selected="current == index + 1 ? true : null"
            v-for="(suggestion, index) in suggestions">
              <span class="c-predictive-item-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="25" aria-hidden="true" role="presentation"><path fill-rule="evenodd" d="M9 0C4.024 0 0 3.912 0 8.75 0 15.313 9 25 9 25s9-9.688 9-16.25C18 3.912 13.976 0 9 0zm0 12a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6z"/></svg></span>
              {{ suggestion.description }}
          </li>
        </ul>
        <div class="c-predictive-logo">
          <img src="/images/powered_by_google.png" alt="Powered by Google">
        </div>
      </div>
    </div>
    <div class="c-form-field c-form-field-submit">
      <button v-on:click.stop.prevent="submit()" class="c-button c-button-primary c-form-compressed-button">{{ searchBtn }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Two-way binding is not allowed in Vue 2 and so we have to use v-model 
    // which will update the value of the property in the parent component, 
    // when input event is emitted from the child component

    //  If we have to use v-model for a component, then it must have a 
    //  value property and emit input event

    // bind the suggestions Array to the suggestions property and the selected 
    // value will be passed to v-model from the child component and stored into 
    // 'q' which is a data in parent component
    value: {
      type: String,
      required: true
    },
    searchLabel: {
      type: String,
      required: true
    },
    srLabel: {
      type: String,
      required: true
    },
    searchBtn: {
      type: String,
      required: true
    },
    suggestions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      // current holds the index of the suggestions currently in focus
      current: 0,
      open: false
    }
  },
  computed: {
    openSuggestion() {
      return this.q !== '' &&
             this.suggestions.length !== 0 &&
             this.open === true
    }
  },
  methods: {
    // Triggered the input event to cascade the updates to 
    // parent component    
    updateValue (value) {
      if (this.open === false) {
        this.open = true
        this.current = 0
      }
      this.$emit('input', value);
      this.$parent.getSuggestions();
    },
    submit (value) {
      this.open = false;
      if (this.current != 0) {
        // if they have selected an option - do this
        this.$parent.handleUserInput(this.suggestions[this.current - 1].description);
      } else {
        // if they pressed enter or submit check for suggestions and replace input
        value = this.suggestions.length ? this.suggestions[0].description : this.value;
        this.$emit('input', value);
        this.$parent.handleUserInput(value);
      }
    },
    click (value) {
      this.$emit('input', value);
      this.$parent.handleUserInput(value);
    },
    // when focus leaves the input, close all the suggestions
    blur () {
      // delay the focus out event in case a user has clicked one of the results - there might be a better way to do this?
      var vm = this;
      setTimeout(function() {
        vm.open = false;
        vm.current = 0;
      }, 500)
    },
    // filter up through active suggestions
    up () {
      if (this.current > 1) {
        this.current--;
      } else if (this.current == 1) {
        this.current = 0;
        return
      } else {
        this.current = this.suggestions.length;
      }
      this.$emit('input', this.suggestions[this.current - 1].description);
    },
    // filter down through active suggestions
    down () {
      if (this.current < this.suggestions.length) {
        this.current++;
      } else {
        this.current = 0;
        return
      }
      this.$emit('input', this.suggestions[this.current - 1].description);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/vue/_autocomplete.vue